export const createFeedbackElement = (beforeElement: HTMLElement) => {
    const feedback = document.createElement(`p`);
    feedback.style.color = `red`;
    feedback.style.fontSize = `0.75rem`;
    feedback.innerHTML = `&nbsp;`;
    beforeElement.parentNode?.insertBefore(feedback, beforeElement);
    return feedback;
};
